import React from 'react';
import { ReactComponent as CheckCircle } from '../../../../assets/icons/svg/checkCircle.svg';
import { ReactComponent as DotSVG } from '../../../../assets/icons/svg/dot.svg';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navBenefits.module.css';

// 상세 페이지 혜택 탭의 리스트 표시 컴포넌트
function navBenefits({ ...data }) {
  const benefitsData = data.benefit;
  return (
    <div className={styles['benefits-info']}>
      {/* 혜택사항 타이틀 */}
      <div className={styles['benefits-info-left']}>
        <CheckCircle className={styles['check-circle']} />
        혜택사항
      </div>

      {/* 혜택사항 내용 */}
      <div className={styles['benefits-contents']}>
        {benefitsData.map((item, idx) => (
          <div key={idx} className={styles['benefits-section']}>
            {item.title && <div className={styles['benefits-title']}>{item.title}</div>}

            <ul className={styles['benefits-list']}>
              {item.items.map((benefit, i) => (
                <li key={i} className={styles['benefits-item']}>
                  <div className={styles.dotWrapper}>
                    <DotSVG />
                  </div>
                  {benefit}
                </li>
              ))}
            </ul>

            {Array.isArray(item.notes) && item.notes.length > 0 && (
              <div className={styles['benefits-notes']}>
                {item.notes.map((note, i) => (
                  <div key={i}>{note}</div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default navBenefits;
